<app-auth-creative>
  <form class="form w-100" novalidate="novalidate" action="#">
    <!--begin::Heading-->
    <div class="text-center mb-11">
      <!--begin::Title-->
      <h1 class="text-dark fw-bolder mb-3">Klientų zona</h1>
      <!--end::Title-->
      <!--begin::Subtitle-->
      <div class="text-gray-500 fw-semibold fs-6">Prisijunkite su</div>
      <!--end::Subtitle=-->
    </div>
    <!--begin::Heading-->
    <!--begin::Login options-->
    <met-notification-container></met-notification-container>
    <div class="row g-3 mb-9">
      <!--begin::Col-->
      <div class="col-md-12">
        <div id="gsi" class="d-flex justify-content-center"></div>
      </div>
      <!--end::Col-->
    </div>
    <!--end::Login options-->
    <!--begin::Separator-->
    <div class="separator separator-content my-14">
      <span class="w-125px text-gray-500 fw-semibold fs-7"
        >Arba su el. paštu</span
      >
    </div>
    <!--end::Separator-->
    <!--begin::Input group=-->
    <div class="fv-row">
      <!--begin::Email-->
      <input
        type="text"
        placeholder="El. paštas"
        name="email"
        autocomplete="off"
        class="form-control bg-transparent"
        [formControl]="email"
        [class.is-invalid]="email.touched && email.errors"
      />
      <met-feedback-container>
        <met-feedback
          *ngIf="email.touched && email.hasError('required')"
          [invalid]="true"
        >
          Įveskite el. pašto adresą
        </met-feedback>
        <met-feedback
          *ngIf="email.touched && email.hasError('email')"
          [invalid]="true"
        >
          Netinkamai įvestas el. pašto adresas
        </met-feedback>
        <met-feedback *ngIf="status === 'not_found'" [invalid]="true">
          Vartotojas neegzistuoja arba blogai įvestas slaptažodis
        </met-feedback>
        <met-feedback *ngIf="status === 'no_internet'" [invalid]="true">
          Patikrinkite interneto ryšį ir bandykite dar kartą
        </met-feedback>
        <met-feedback *ngIf="status === 'unknown'" [invalid]="true">
          Iškilo nežinoma sistemos klaida
        </met-feedback>
      </met-feedback-container>
      <!--end::Email-->
    </div>
    <!--end::Input group=-->
    <div class="fv-row mb-3">
      <!--begin::Password-->
      <input
        type="password"
        name="password"
        placeholder="Slaptažodis"
        autocomplete="off"
        class="form-control bg-transparent"
        [formControl]="password"
        [class.is-invalid]="password.dirty && password.errors"
      />
      <met-feedback-container>
        <met-feedback
          *ngIf="password.touched && password.hasError('required')"
          [invalid]="true"
        >
          Įveskite slaptažodį
        </met-feedback>
        <met-feedback
          *ngIf="password.dirty && password.hasError('minlength')"
          [invalid]="true"
        >
          Min. {{ password.getError('minlength').actualLength }}/{{
            password.getError('minlength').requiredLength
          }}
          simboliai
        </met-feedback>
        <met-feedback
          *ngIf="password.dirty && password.hasError('maxlength')"
          [invalid]="true"
        >
          Maks. {{ password.getError('maxlength').actualLength }}/{{
            password.getError('maxlength').requiredLength
          }}
          simboliai
        </met-feedback>
        <met-feedback *ngIf="status === 'not_found'" [invalid]="true">
          Vartotojas neegzistuoja arba blogai įvestas slaptažodis
        </met-feedback>
        <met-feedback *ngIf="status === 'no_internet'" [invalid]="true">
          Patikrinkite interneto ryšį ir bandykite dar kartą
        </met-feedback>
        <met-feedback *ngIf="status === 'unknown'" [invalid]="true">
          Iškilo nežinoma sistemos klaida
        </met-feedback>
      </met-feedback-container>
      <!--end::Password-->
    </div>
    <!--end::Input group=-->
    <!--begin::Wrapper
    <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
      <div></div>
      <a [routerLink]="['..', 'forgot-password']" class="link-primary"
        >Pamiršote slaptažodį?</a
      >
    </div>
    end::Wrapper-->
    <!--begin::Submit button-->
    <div class="d-grid mb-10">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="loading"
        [attr.data-kt-indicator]="loading ? 'on' : null"
        (click)="onSubmit($event)"
      >
        <!--begin::Indicator label-->
        <span class="indicator-label">Prisijungti</span>
        <!--end::Indicator label-->
        <!--begin::Indicator progress-->
        <span class="indicator-progress"
          >Prašome palaukti...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span
        ></span>
        <!--end::Indicator progress-->
      </button>
    </div>
    <!--end::Submit button-->
    <!--begin::Sign up-->
    <div class="text-gray-500 text-center fw-semibold fs-6">
      Nesate klientas?
      <a [routerLink]="['/', 'contact']" class="link-primary">Susisiekite</a>
    </div>
    <!--end::Sign up-->
  </form>
</app-auth-creative>
